import React from 'react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { bemCssModules, getTestId } from '@utils';

import { loginActions, useStore } from '@modules';

import useMenuLinks from '../../useMenuLinks';
import useHelpLink from '../useHelpLink';

import style from './PrivateContent.scss';

const cn = bemCssModules(style, 'PrivateContent');
const ti = getTestId('PrivateContent');

const PrivateContent: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [, dispatch] = useStore();
  const helpLink = useHelpLink();
  const menuLinks = useMenuLinks();

  const logout = () => {
    dispatch(loginActions.logout());
  };

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {menuLinks.map(({ key, url }) => (
        <NavLink
          key={key}
          className={({ isActive }) => cn('link', { isActive }, ['link'])}
          to={url}
        >
          {t(`header.${key}`)}
        </NavLink>
      ))}
      <a className={cn('link', ['link'])} href={helpLink} target="_blank" rel="noreferrer">
        {t('header.help')}
      </a>
      <button className={cn('link', ['link'])} type="button" onClick={logout}>
        {t('header.log_out')}
      </button>
    </div>
  );
};

export default PrivateContent;
